import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, Autocomplete, Select, Box, MenuItem, InputLabel, FormControl, useTheme,
    Typography
} from '@mui/material';
import { tokens } from "../../../theme/theme";

const NewProductVarietyDialog = ({
    open, onClose, onAdd, onClear, newProductVariety = {}, handleInputChange,
    valuePG, onChange, options, getOptionLabel, error, helperText,
    valuePSB, onChange1, options1, getOptionLabel1, error1, helperText1
}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

   
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                style: {
                    position: 'absolute',
                    top: 0,
                    margin: '0px', // Adjust as needed
                },
            }}
        >
            <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>
              <Typography variant='h6'> New Product Variety</Typography>
            </DialogTitle>
            <DialogContent style={{ backgroundColor: theme.palette.background.default }}>
                <Autocomplete
                    size="small"
                    sx={{ marginTop: '10px' }}
                    required
                    value={valuePG}
                    onChange={onChange}
                    options={options}
                    getOptionLabel={getOptionLabel}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Product Group"
                           
                            required
                            variant="outlined"
                            // error={Boolean(error)}
                            // helperText={helperText}
                            error={!newProductVariety.PGroupId}
                            helperText={!newProductVariety.PGroupId && "Product Group Code is required"}
                        />
                    )}
                />

                <Autocomplete
                    sx={{ marginTop: '10px' }}
                    id="dropdown_product_subgroup"
                    size='small'
                    value={valuePSB}
                    onChange={onChange1}
                    options={options1}
                    getOptionLabel={getOptionLabel1}
                    renderInput={(params) => (
                        <TextField {...params}
                            label="Product Sub Group"
                            variant="outlined"                        
                            required
                            // error={Boolean(error1)}
                            // helperText={helperText1}
                            error={!newProductVariety.PSubGroupId}
                            helperText={!newProductVariety.PSubGroupId && "Product Sub Group Code is required"}
                        />
                    )}
                />

                <TextField
                    autoFocus
                    margin="dense"
                    name="PVarietyCode"
                    size='small'
                    label="Product Variety Code"
                    fullWidth
                    value={newProductVariety.PVarietyCode|| ''}
                    onChange={handleInputChange}
                    required
                    error={!newProductVariety.PVarietyCode}
                    helperText={!newProductVariety.PVarietyCode && "Product Variety code is required"}
                />

                <TextField
                    margin="dense"
                    name="PVarietyDesc"
                    size='small'
                    label="Product Variety Desc"
                    fullWidth
                    value={newProductVariety.PVarietyDesc || ''}
                    onChange={handleInputChange}
                    required
                    error={!newProductVariety.PVarietyDesc}
                    helperText={!newProductVariety.PVarietyDesc && "Product Variety desc is required"}
                />

                <FormControl fullWidth margin="dense" size='small'>
                    <InputLabel>Status</InputLabel>
                    <Select
                        name="PVarietyStatus"
                        value={newProductVariety.PVarietyStatus || ''}
                        onChange={handleInputChange}
                    >
                        {/* <MenuItem value=""><em>None</em></MenuItem> */}
                        <MenuItem value="A">Active</MenuItem>
                        <MenuItem value="IA">Inactive</MenuItem>
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
                <Box justifyContent={'space-between'} >
                    <Button
                        variant='contained'
                        style={{ fontSize: '12px', marginRight: '8px', textTransform: 'none', backgroundColor: '#1769aa' }}
                        onClick={onAdd}
                    >
                        Save
                    </Button>

                    <Button
                        variant='contained'
                        onClick={onClear}
                        style={{ marginRight: '10px', fontSize: '12px', backgroundColor: '#c5c7c6', color: 'black', textTransform: 'none' }}
                    >
                        Clear
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default NewProductVarietyDialog;
